// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2Chxe","calendarButtons":"ClockData_calendarButtons__2-SoE"};